import React, { useState, useRef, useEffect } from 'react';
import { Globe, Check } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';

export const LanguageSwitcher = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { currentLang, changeLanguage, languages } = useLanguage();
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const currentLanguage = languages.find(lang => lang.code === currentLang);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        data-testid="language-switcher-btn"
        className="flex items-center gap-2 px-3 py-2 rounded-lg text-slate-300 hover:text-white hover:bg-slate-800/50 transition-colors text-sm"
        aria-label="Change language"
      >
        <Globe className="w-4 h-4" />
        <span className="hidden sm:inline">{currentLanguage?.flag}</span>
        <span className="uppercase text-xs font-semibold">{currentLang}</span>
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-slate-900 border border-slate-700 rounded-lg shadow-xl py-1 z-50">
          {languages.map((lang) => (
            <button
              key={lang.code}
              data-testid={`language-option-${lang.code}`}
              onClick={() => {
                changeLanguage(lang.code);
                setIsOpen(false);
              }}
              className="w-full px-4 py-2 text-left flex items-center gap-3 hover:bg-slate-800 transition-colors text-sm"
            >
              <span className="text-xl">{lang.flag}</span>
              <span className="flex-1 text-slate-300">{lang.name}</span>
              {currentLang === lang.code && (
                <Check className="w-4 h-4 text-cyan-400" />
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
